module.exports = "<ea-know-your-customer-capture-form-page></ea-know-your-customer-capture-form-page>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaAdministration/eaKnowYourCustomer/eaKnowYourCustomerCaptureFormPage/eaKnowYourCustomerCaptureFormPageModule.html
// module id = 957
// module chunks = 12